import { MenuEntry } from '../../../../ducks/app';

const menuData: MenuEntry[] = [
  {
    title: 'FileAnAppeal Page',
    key: 'empty',
    url: '/empty',
    icon: 'icmn icmn-books',
  },
];

export default menuData;
